import { useMemo } from 'react';
import moment from 'moment-timezone';

/**
 * Determines if the activity start time is inside the cancellation window.
 *
 * @param {Object} bookingItem - The booking item object containing activity_start and activity data
 * @returns {{ isStartInsideCancelWindow: boolean }}
 */
export function useCancelWindow(bookingItem) {
    return useMemo(() => {
        if (!bookingItem?.activity_start) {
            return { isStartInsideCancelWindow: true };
        }

        const activityStart = bookingItem.activity_start;
        const cancellationWindow = bookingItem.activity?.cancellation_window || 0;

        // Get timezone from activity or island, fallback to Hawaii
        const timezone =
            bookingItem.activity?.timezone ||
            bookingItem.activity?.island?.timezone ||
            'Pacific/Honolulu';

        const cancelWindowTime = moment(activityStart)
            .tz(timezone, true)
            .subtract(cancellationWindow, 'hours');

        const isStartInsideCancelWindow = moment()
            .tz(timezone)
            .isAfter(cancelWindowTime);

        return { isStartInsideCancelWindow };
    }, [
        bookingItem?.activity_start,
        bookingItem?.activity?.cancellation_window,
        bookingItem?.activity?.timezone,
        bookingItem?.activity?.island?.timezone
    ]);
}
